import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DependencyTree/nodes/ReferenceNodeContent/ReferenceNodeContent.tsx";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.function.name.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { useHoverWithRef } from '@gmini/utils';
import { NodeMoreActionButton } from '@gmini/ui-kit';
import { mergeReactRefs } from '@gmini/utils/lib/mergeReactRefs';
import { useDragLayer } from 'react-dnd';
import { NumCircle, NumCircleWrap } from "../../../../components";
import { buildKeyByPath } from "../../../ClassifierTree/utils";
import { NodeExpand } from "../../../NodeExpand";
import { NodeCheckbox } from "../../../ClassifierTree/NodeCheckbox";
import { NodeLayout } from "../../NodeLayout";
import { BimNodeIcon } from "../../../ClassifierTree/BimNodeIcon";
import { useNodeCtxMenu } from "../../../ClassifierTree/TreeContextMenu/ctx";
import { DndType } from "../../../DragNDrop/dndType";
import { useDragWithBeginDelay } from "../../../DragNDrop/useDragWithBeginDelay";
import { useHasUpdates } from "../../../Migration";
import { VersionButton as NotLoadedVersionButton } from "../../../SelectDependencies/ModelsTree/VersionButton/VersionButton";
import { VersionButton } from "../common";
import { useReadonlyMode } from "../../../../hooks";
import { getStyle } from "../../../Common/getStyle";
import { DndOverNodeContent } from "../../../Common/UI/DndOverNodeContent";
import { OverNodeBorder } from "../../../Common/UI/DndOverNodeContent.styled";
import { isHighlightedInSearch } from "../../../Common/isHighlightedInSearch";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ReferenceNodeContent = function ReferenceNodeContent(_ref) {
  var _notLoadedModel$forge, _model$forgeData;

  var node = _ref.node,
      onClickNode = _ref.onClickNode,
      onExpandClick = _ref.onExpandClick,
      onDoubleClickNode = _ref.onDoubleClickNode,
      path = _ref.path,
      isExpanded = _ref.isExpanded,
      isSelected = _ref.isSelected,
      onCheckedNode = _ref.onCheckedNode,
      checkbox = _ref.checkbox,
      clsDependencies = _ref.clsDependencies,
      inSearch = _ref.inSearch,
      onPending = _ref.onPending,
      RenderNodeLayout = _ref.renderNodeLayout,
      onUpdateDialogOpen = _ref.onUpdateDialogOpen,
      highlighted = _ref.highlighted,
      _ref$showModelVersion = _ref.showModelVersion,
      showModelVersion = _ref$showModelVersion === void 0 ? true : _ref$showModelVersion,
      inSearchSource = _ref.inSearchSource;

  var _useNodeCtxMenu = useNodeCtxMenu({
    path: path
  }),
      onContextMenu = _useNodeCtxMenu.onContextMenu,
      open = _useNodeCtxMenu.open,
      onClickOpen = _useNodeCtxMenu.onClickOpen;

  var matched = inSearch.matched,
      fullMatch = inSearch.fullMatch;
  var ref = React.useRef(null);
  var hasUpdates = useHasUpdates(node.parentClassifierId);

  var _useReadonlyMode = useReadonlyMode(),
      readonlyMode = _useReadonlyMode.readonlyMode;

  var model = node.type === 'ReferenceNode' && node.element.type === 'BimModelNode' && path.length <= 1 ? node.element : null;
  var notLoadedModel = model && model.status !== 'ImportCompleted' ? model : null;

  var _useDragWithBeginDela = useDragWithBeginDelay({
    item: {
      type: DndType.FROM_DEPENDENCIES
    },
    begin: function begin() {
      onCheckedNode(true);
    },
    collect: function collect(m) {
      return {
        isDragging: m.isDragging()
      };
    },
    canDrag: !readonlyMode.enabled && !notLoadedModel
  }),
      _useDragWithBeginDela2 = _slicedToArray(_useDragWithBeginDela, 3),
      isDragging = _useDragWithBeginDela2[0].isDragging,
      dragRef = _useDragWithBeginDela2[1],
      preview = _useDragWithBeginDela2[2];

  var _useDragLayer = useDragLayer(function (monitor) {
    return {
      someoneDragging: monitor.isDragging()
    };
  }),
      someoneDragging = _useDragLayer.someoneDragging;

  var _useHoverWithRef = useHoverWithRef(ref),
      hover = _useHoverWithRef.hover,
      onMouseLeave = _useHoverWithRef.onMouseLeave,
      onMouseOver = _useHoverWithRef.onMouseOver;

  React.useEffect(function () {
    preview(getEmptyImage(), {
      captureDraggingState: false
    });
  }, [preview]);
  var element = node.element;
  var expandable = 'total' in element && element.total > 0;
  var depIdx = clsDependencies.findIndex(function (_ref2) {
    var id = _ref2.id;
    return id === node.parentClassifierId;
  });
  var sourceCls = depIdx >= 0 ? clsDependencies[depIdx] : null;

  var _isHighlightedInSearc = isHighlightedInSearch({
    matched: matched,
    fullMatch: fullMatch,
    isExpanded: isExpanded,
    highlighted: highlighted
  }),
      highlightedInSearch = _isHighlightedInSearc.highlightedInSearch;

  var style = getStyle({
    highlightedInSearch: highlightedInSearch,
    hover: open || hover,
    isSelected: isSelected,
    isDragging: isDragging,
    someoneDragging: someoneDragging,
    canDrop: false
  });
  var background = path.length === 1 && inSearchSource ? {
    background: '#F4F4F8'
  } : undefined;

  var expandHandler = function expandHandler() {
    if (onExpandClick && !notLoadedModel) {
      onExpandClick();
    }
  };

  var nodeLayoutProps = {
    ref: mergeReactRefs(ref, dragRef),
    icon: /*#__PURE__*/_jsx(BimNodeIcon, {
      type: node.element.type === 'BimModelNode' ? node.element.modelType : node.element.type
    }),
    text: element.name,
    onClick: onClickNode,
    // TODO: использовать onDoubleClickNode
    onDoubleClick: expandHandler,
    onExpand: expandHandler,
    onContextMenu: onContextMenu,
    onMouseOver: onMouseOver,
    onMouseLeave: onMouseLeave,
    style: _objectSpread(_objectSpread({}, style), background),
    textStyle: {
      color: style.color
    },
    expandJsx: /*#__PURE__*/_jsx(NodeExpand, {
      onClick: expandHandler,
      unavailable: !!notLoadedModel,
      expanded: isExpanded,
      hidden: !expandable,
      hovered: hover
    }),
    checkbox: /*#__PURE__*/_jsx(NodeCheckbox, _objectSpread(_objectSpread({}, checkbox), {}, {
      disabled: !!notLoadedModel,
      onChange: function onChange(_, value) {
        return onCheckedNode(value);
      }
    })),
    deepness: path.length - 1,
    numCycle: model && sourceCls && depIdx + 1 > 0 && /*#__PURE__*/_jsx(NumCircleWrap, {
      children: /*#__PURE__*/_jsx(NumCircle, {
        disabled: true,
        styleProps: path.length === 1 && inSearchSource ? {
          background: 'rgba(199, 200, 202, 1)',
          border: '1px solid rgba(199, 200, 202, 1)'
        } : undefined,
        children: depIdx + 1
      })
    }),
    moreActionButton: /*#__PURE__*/_jsxs(_Fragment, {
      children: [(notLoadedModel === null || notLoadedModel === void 0 ? void 0 : (_notLoadedModel$forge = notLoadedModel.forgeData) === null || _notLoadedModel$forge === void 0 ? void 0 : _notLoadedModel$forge.forgeVersionName) && /*#__PURE__*/_jsx(NotLoadedVersionButton, {
        status: notLoadedModel.status,
        showVersion: true,
        versionName: notLoadedModel.forgeData.forgeVersionName,
        author: notLoadedModel.author,
        uploadDate: notLoadedModel.uploadDate,
        errorCode: notLoadedModel.errorCode
      }), showModelVersion && model && !notLoadedModel && /*#__PURE__*/_jsx(VersionButton, {
        versionName: model.modelType === 'AssemblyModel' ? node.parentClassifierVersion : ((_model$forgeData = model.forgeData) === null || _model$forgeData === void 0 ? void 0 : _model$forgeData.forgeVersionName) || 0,
        hasActions: hasUpdates,
        author: model.author,
        uploadDate: model.uploadDate,
        onClick: function onClick(e) {
          e.stopPropagation();

          if (onUpdateDialogOpen) {
            onUpdateDialogOpen({
              sourceClassifierId: node.parentClassifierId,
              modelName: model.name,
              modelType: model.modelType
            });
          }
        }
      }), /*#__PURE__*/_jsx(NodeMoreActionButton, {
        show: hover || open,
        active: open,
        onClick: onClickOpen
      })]
    }),
    hover: hover,
    pending: onPending(buildKeyByPath(path)),
    highlightedInSearch: highlightedInSearch,
    overLayoutContent: /*#__PURE__*/_jsx(DndOverNodeContent, {
      isMiddleOver: false,
      isDragging: isDragging,
      canDrop: false,
      overContent: /*#__PURE__*/_jsx(OverNodeBorder, {})
    })
  };

  if (RenderNodeLayout) {
    return RenderNodeLayout({
      node: node,
      nodeLayoutProps: nodeLayoutProps,
      path: path
    });
  }

  return /*#__PURE__*/_jsx(NodeLayout, _objectSpread({}, nodeLayoutProps));
};